module.exports = __webpack_public_path__ + "static/media/gmdmono1.9e59584d.png";